import { FaStar, FaRegStar } from "react-icons/fa";
export const renderStars = (stars) => {
  const totalStars = 5;
  return [...Array(totalStars)].map((_, index) =>
    index < stars ? (
      <FaStar key={index} className="text-warning" />
    ) : (
      <FaRegStar key={index} className="text-warning" />
    )
  );
};

export const fetchData = async (url) => {
  try {
    const response = await fetch("https://admin.energybazzar.com/" + url); // Make the GET request
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`); // Handle HTTP errors
    }
    const data = await response.json(); // Parse JSON response
    return data; // Return the data
  } catch (error) {
    console.error("Failed to fetch data:", error.message);
    return null; // Return null in case of an error
  }
};
